module.exports = __webpack_public_path__ + "static/zergbem-520ae5c348e51615b200eacbbff6a4a8.jpg";